/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as _ from 'underscore';

class SocialButtonConnect extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }


    onClick(service, e) {

        let url = '/remote/begin?fx=auth&isID=:isId&state=:state&final=:final',
            date = new Date(),
            state = ['INPUT', service, date.getTime()].join('_'),
            constants = this.props.app.config.constants;

        if (service == constants.INPUT_TYPE_TWITTER) {
            if (this.props.user.perms.resources.inputTwitter === 0) {
                this.props.showUpgradeModal(this.props.closeAllModals, 'twitterInput', null, this.props.context + '_create');
                return;
            }
        }

        if (typeof this.props.beforeClick === "function") {
            this.props.beforeClick.apply(this, [service]);
        }

        // allows an override of the default click behavior (looking at you multiple feed subtypes)
        if (typeof this.props.onClick === "function") {
            this.props.onClick.apply(this, [e, service]);
            return;
        }

        url = url.replace(':isId', service);
        url = url.replace(':state', state);
        // if a # is on the url it somehow mucks up things in remote and the proper
        // url doesn't get returned to the browser
        let finalUrl = this.props.cleanUrl(window.location.href);
        url = url.replace(':final', window.encodeURIComponent(finalUrl));

        window.location.assign(url);

    }

    render() {

        let service = this.props.service,
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(service)],
            icon = null,
            serviceName = ConstantMixin.getInputServiceByCode(service);

        if (this.props.icon && this.props.icon.match(/icon|fa\b/)) {
            icon = (
                <i className={`${this.props.icon} tile-icon`}></i>
            );
        } else {
            icon = (
                <img src={this.props.icon} width="30" height="30"/>
            );
        }

        const debouncedOnClick = _.debounce(this.onClick, 300, true);

        return (
            <div className="input-tile" onClick={debouncedOnClick.bind(null, service)} role="button" aria-label={`connect ${serviceName}`}>
                <div className="tile-img">
                    {icon}
                </div>
                <div className="tile-label">
                    {this.props.serviceLabel}
                </div>
            </div>
        );

    }

};

SocialButtonConnect.propTypes = {
    service: PropTypes.number,
    beforeClick: PropTypes.func,
    onClick: PropTypes.func,
    userPerms: PropTypes.object,
    recordPath: PropTypes.func,
    router: PropTypes.object,
    setModal: PropTypes.func,
    context: PropTypes.string,
    outline: PropTypes.bool,
    square: PropTypes.bool
};

SocialButtonConnect.defaultProps = {
    service : 'default',
    beforeClick: null,
    onClick: null,
    userPerms: {},
    recordPath: null,
    router: null,
    setModal: null,
    context: '',
    outline: false,
    square: false
};

export default SocialButtonConnect;
